import DownloadCv from "./DownloadCv";
const NavBar = ({ pageLoaded }) => {

    return (
        <div className={`initial-scale-animation-navbar backdrop-blur-[7px] dark:bg-cDarkBG2/30 bg-white/20 border border-white/10 rounded-full dark:text-cDarkText text-gray-700 shadow-lg w-[calc(100vw-120px)] mx-auto xl:flex items-center justify-between py-2 sm:py-3 px-10 relative hidden`}>
            <a
                href="/#about"
                className="animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent text-3xl font-medium drop-shadow-sm"
            >
                zamanShahed
            </a>
            <div className="absolute left-[50%] -translate-x-[50%]">
                <div className="flex items-center font-normal text-lg space-x-10">
                    <a href="/#about" className="cursor-pointer">
                        About
                    </a>
                    <a href="/#skills" className="cursor-pointer">
                        Skills
                    </a>
                    <a href="/#education" className="cursor-pointer">
                        Education
                    </a>
                    <a href="/#experience" className="cursor-pointer">
                        Experience
                    </a>
                    <a href="/#contributions" className="cursor-pointer">
                        Contributions
                    </a>
                </div>
            </div>
            {/*  */}

            <div className="flex items-center space-x-5">
                <div className="w-full max-w-[422px] [background:linear-gradient(45deg,#172033,theme(colors.slate.800)_50%,#172033)_padding-box,conic-gradient(from_var(--border-angle),theme(colors.slate.600/.48)_80%,_theme(colors.indigo.500)_86%,_theme(colors.indigo.300)_90%,_theme(colors.indigo.500)_94%,_theme(colors.slate.600/.48))_border-box] rounded-xl border border-transparent animate-border">
                    <div className="">
                        <DownloadCv />
                    </div>
                </div>
                {/* <div className="text-2xl cursor-pointer">
                    {isDarkMode ? (
                        <WiDaySunny
                            onClick={() => {
                                localStorage.setItem("color-theme", "light");
                                setIsDarkMode(false);
                            }}
                        />
                    ) : (
                        <MdDarkMode
                            onClick={() => {
                                localStorage.setItem("color-theme", "dark");
                                setIsDarkMode(true);
                            }}
                        />
                    )}
                </div> */}
            </div>
        </div>
    );
};

export default NavBar;
